module.exports = __webpack_public_path__ + "static/media/MM50-2MTJ.2dc3f96f.png";